// Repite `pedir` cada `cada` milisegundos solo mientras la pestaña está a la
// vista, y pide una vez más apenas el jugador vuelve a ella: lo que se veía
// puede haber quedado viejo. Una pestaña olvidada en segundo plano no tiene
// por qué seguir bajando el catálogo (~223 KB) cada 30 segundos.
//
// Devuelve la función que lo apaga, pensada para el `return` de un useEffect.
export function sondearConPestanaVisible(pedir, cada){
  const t=setInterval(()=>{ if(!document.hidden) pedir(); },cada);
  const alVolver=()=>{ if(!document.hidden) pedir(); };
  document.addEventListener("visibilitychange",alVolver);
  return()=>{
    clearInterval(t);
    document.removeEventListener("visibilitychange",alVolver);
  };
}
